import React from "react";

import {
    Dialog,
    DialogContent,
    DialogContentText,
    Box,
    Button,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@mui/material";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useUtilityContext } from "../../../utility-provider";
import { setAddSurveyObj } from "../../../features/locationAddSurveySlice";
import { setApprovalStatus } from "../../../features/approvalSurveySlice";
import { apiRequest, postPython } from "../../../api/ApiCall";
import MessageDialog from "../../components/MessageDialog";
import { LOCAL_CONSTANT } from "../../Const";
import { userLogging } from "../../../utility/firestore";
import { encryptQueryParam } from "../../../utility/util";
import { useUserContext } from "../../../user-provider";
import { getStaffNoList } from "../../mailFunction";
import { mailDetail } from "../../mailTemplate";
import { settingTaskId } from "../../components/LocationAddSurveyFunc";

export interface approvalSurveyModalProps {
    props: {
        open: boolean;
        handleModal: any;
        planAreaId: string | null;
        branch: string | null;
        userData: any;
        receptionBook: any;
        planAreaInfoData: any;
    };
}

const ApprovalSurveyModal: React.FC<approvalSurveyModalProps> = ({ props }) => {
    const dispatch = useAppDispatch();
    const utilityCtx = useUtilityContext();
    const user = useUserContext();

    const [open, setOpen] = React.useState(false);

    const objLocationAddSurvey = useAppSelector(
        (state) => state.locationAddSurvey.obj
    );
    const cover = useAppSelector((state) => state.locationAddSurvey.objcover);
    const objApprovalSurvey = useAppSelector(
        (state) => state.approvalSurvey.approvalStatus
    );

    const [message, setMessage] = React.useState<string>("");
    const [messageDialogOpen, setMessageDialogOpen] =
        React.useState<boolean>(false);
    const [hasButton, setHasButton] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (props.open) {
            setOpen(props.open);
        }
    }, [props.open]);

    const handleClose = () => {
        dispatch(
            setApprovalStatus({
                ...objApprovalSurvey,
                additionalResearch: "",
            })
        );
        setOpen(false);
        props.handleModal();
    };

    const handleRadioChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        labelName: string
    ) => {
        dispatch(
            setApprovalStatus({
                ...objApprovalSurvey,
                [labelName]: e.target.value,
            })
        );
    };

    const handleDisabled = () => {
        let disabled = false;
        if (objApprovalSurvey.additionalResearch === "") {
            disabled = true;
        }

        return disabled;
    };

    const onRegist = () => {
        (async () => {
            //差戻フラグ(差戻 = true、承認 = false)
            const sendBackFlag: boolean = objApprovalSurvey.additionalResearch === "0";
            try {
                if (utilityCtx.showSpinner) {
                    utilityCtx.showSpinner();
                }
                // メッセージモーダル表示
                setHasButton(false);
                if (sendBackFlag) {
                    setMessage("差戻中です");
                } else {
                    setMessage("承認中です");
                }
                setMessageDialogOpen(true);
                const managerName = props.userData.user_name;
                let department = "";
                const staffMasterObj = localStorage.getItem("staffMaster");
                if (staffMasterObj !== null) {
                    const jsonStaffMasterObj = JSON.parse(staffMasterObj);
                    jsonStaffMasterObj.forEach((row: any) => {
                        if (
                            row.department_code_oa ===
                            props.userData.department_code_OA
                        ) {
                            department = row.department_name_oa;
                        }
                    });
                }

                // 印影の作成
                const paythonParams = {
                    mode: "regist",
                    endPoint: "/make-iner",
                    query: {
                        prop_site_no: props.planAreaId,
                        branch: props.branch,
                        managerName: managerName,
                        department: department,
                    },
                };
                const result = await postPython(paythonParams);
                let paramsData: any = {};
                if (result.data.data.inei_file_path) {
                    paramsData = await approvalMain({
                        planAreaId: props.planAreaId,
                        branch: props.branch,
                        inei_file_path: result.data.data.inei_file_path,
                        target: "parent",
                        target_plan_area_id: props.planAreaId,
                        planAreaInfoData: props.planAreaInfoData,
                        userData: props.userData,
                        sendBackFlag: sendBackFlag,
                    });
                }
                const params = {
                    mode: "regist",
                    endPoint: "/excel-add-print-pdf",
                    query: {
                        plan_area_id: props.planAreaId,
                        branch: props.branch,
                        file_name: objLocationAddSurvey.cover_confirm_pdf_path
                            .toString()
                            .replace("/pdf/", ""),
                        task_id: paramsData.taskId,
                        mode: "approval",
                    },
                };
                userLogging(
                    LOCAL_CONSTANT.FUNCTION_NAME.APPROVAL_SURVEY_PDF,
                    params,
                    user
                );
                // PDF変換
                if (
                    ["E003", "E008", "E015", "E018"].includes(paramsData.taskId)
                ) {
                    await postPython(params);
                }
                let addSurvey = JSON.parse(
                    JSON.stringify(paramsData.addSurvey)
                );
                addSurvey.doc_pdf_path = JSON.parse(addSurvey.doc_pdf_path);
                dispatch(setAddSurveyObj(addSurvey));
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
                // 依頼コメント画面と同様に、承認後はモーダルを閉じないよう閉じるボタンを非表示
                setHasButton(false);
                if (sendBackFlag) {
                    setMessage("差し戻しました");
                } else {
                    setMessage("承認しました");
                }
            } catch (e) {
                console.log(e);
                setHasButton(true);
                if (sendBackFlag) {
                    setMessage("差戻に失敗しました");
                } else {
                    setMessage("承認に失敗しました");
                }
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    const approvalMain = async (param: any) => {
        const paramsData = settingTaskId(param, {
            objApprovalSurvey: objApprovalSurvey,
            objLocationAddSurvey: objLocationAddSurvey,
            userData: props.userData,
            task_id: props.receptionBook?.task_id,
        });

        let titleDetail = "";
        let staffNoList: any = [];
        let detail: any = {};
        const urlQueryParam = `planAreaId=${props.planAreaId}&branch=${props.branch}`;
        const encryptedQueryParam = await encryptQueryParam(urlQueryParam);

        if (paramsData.hasMail) {
            let mailDetailTarget = "requestCommentAddSurvey";
            let staffNoListTarget = "addSurvey";
            if (["E003"].includes(paramsData.taskId)) {
                mailDetailTarget = "addSurvey";
            }
            if (["E015"].includes(paramsData.taskId)) {
                mailDetailTarget = "requestCommentAddSurveyConfirmed";
                staffNoListTarget = "addSurveyRR";
            }
            staffNoList = getStaffNoList(staffNoListTarget, {
                staffMasterObj: localStorage.getItem("staffMaster"),
                planAreaInfoData: param.planAreaInfoData,
            });
            const mailDetailParam = {
                survey_name: cover.survey_name,
                titleDetail: titleDetail,
                url: `${process.env.REACT_APP_HOST}/approval-survey?${encryptedQueryParam}`,
                rfc: cover.survey_creator,
                type: "01",
                staffNoList: staffNoList,
                plan_area_id: props.planAreaId,
                branch: props.branch,
                notficationType: "01",
            };  
            detail = mailDetail(mailDetailTarget, mailDetailParam);
        }
        const params = {
            mode: "regist",
            endPoint: "/location/Reception/v1/approvalAddSurvey",
            query: {
                plan_area_id: param.planAreaId,
                branch: param.branch,
                task_id: paramsData.taskId,
                addSurveyData: paramsData.addSurvey,
                detail: detail,
                userData: param.userData,
                sendBackFlag: param.sendBackFlag,
            },
        };
        await apiRequest(params);

        return paramsData;
    };

    const closeMessageDialog = () => {
        handleClose();
        setMessage("");
        setHasButton(false);
        setMessageDialogOpen(false);
    };

    return (
        <div>
            <Dialog
                open={open}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                sx={{ display: messageDialogOpen ? "none" : "block" }}
            >
                <DialogContent>
                    <Box>
                        <DialogContentText
                            id="alert-dialog-slide-description"
                            sx={{ whiteSpace: "pre-wrap" }}
                        >
                            「追加調査」を承認しますか
                        </DialogContentText>
                        <RadioGroup
                            row
                            onChange={(e) =>
                                handleRadioChange(e, "additionalResearch")
                            }
                            value={objApprovalSurvey.additionalResearch}
                        >
                            <FormControlLabel
                                value={"1"}
                                control={<Radio />}
                                label={"承認"}
                            />
                            <FormControlLabel
                                value={"0"}
                                control={<Radio />}
                                label={"差戻"}
                            />
                        </RadioGroup>
                    </Box>
                    {["E010", "E012"].includes(
                        props.receptionBook?.task_id
                    ) && (
                        <Box>
                            <DialogContentText
                                id="alert-dialog-slide-description"
                                sx={{ whiteSpace: "pre-wrap" }}
                            >
                                RR GM確認が必要ですか
                            </DialogContentText>
                            <RadioGroup
                                row
                                onChange={(e) =>
                                    handleRadioChange(
                                        e,
                                        "confirmAdditionalResearch"
                                    )
                                }
                                value={
                                    objApprovalSurvey.confirmAdditionalResearch
                                }
                            >
                                <FormControlLabel
                                    value={"1"}
                                    control={<Radio />}
                                    label={"必要"}
                                />
                                <FormControlLabel
                                    value={"0"}
                                    control={<Radio />}
                                    label={"不要"}
                                />
                            </RadioGroup>
                        </Box>
                    )}

                    <Box
                        sx={{ display: "flex", justifyContent: "space-around" }}
                    >
                        <Box sx={{ textAlign: "center", margin: "10px" }}>
                            <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={handleClose}
                            >
                                キャンセル
                            </Button>
                        </Box>
                        <Box sx={{ textAlign: "center", margin: "10px" }}>
                            <Button
                                variant="contained"
                                color="success"
                                size="small"
                                disabled={handleDisabled()}
                                onClick={onRegist}
                            >
                                送信
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
            <MessageDialog
                props={{
                    open: messageDialogOpen,
                    handleModal: closeMessageDialog,
                    body: message,
                    hasButton: hasButton,
                    buttonBody: LOCAL_CONSTANT.LABEL.CLOSE,
                }}
            />
        </div>
    );
};

export default ApprovalSurveyModal;
